// import hooks
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSaveWithCopy } from './hooks/useSaveWithCopy';

// import components
import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/material';
import CLASelect from 'components/shared/CLASelect/CLASelect';
import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';
import ControlledNumericField from 'components/shared/ControlledFields/ControlledNumericField';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

//import utils
import { yupResolver } from '@hookform/resolvers/yup';
import { schema } from './CLASettings.schema';

const CLAForm = ({
  handleClose,
  rowData,
  isCopied
}: FormComponentProps & { isCopied: boolean }) => {
  const { t } = useTranslation('common');
  const { mutate, isLoading } = useSaveWithCopy(
    handleClose,
    isCopied,
    undefined
  );

  const methods = useForm({
    defaultValues: schema(t).cast(rowData),
    resolver: yupResolver(schema(t))
  });

  const { handleSubmit } = methods;

  const onSubmit = (data) => {
    const { claYearId: _, ...rest } = data;
    mutate(isCopied ? rest : data);
    handleClose();
  };

  return (
    <>
      <MultiStepForm onSubmit={handleSubmit(onSubmit)} methods={methods}>
        <MultiStepForm.Section title={t('adminPortal.baseSelection')}>
          <CLASelect />
          <ControlledNumericField
            name="year"
            variant="outlined"
            label={t('year')}
            step={1}
            minValue={0}
          />
        </MultiStepForm.Section>
        <MultiStepForm.Actions>
          <Box display="flex" ml="auto">
            <LoadingButton
              loading={isLoading}
              type="submit"
              variant="contained"
              autoFocus
              color="primary"
            >
              {t('save')}
            </LoadingButton>
          </Box>
        </MultiStepForm.Actions>
      </MultiStepForm>
    </>
  );
};

export default CLAForm;
